const initialState = [];

function analyticsOverviewReducer(state = initialState, action) {
    if (
        action.type === 'LOGOUT_REQUEST' ||
        action.type === 'AUTHENTICATE_REQUEST' ||
        action.type === 'ORDERS_OVERVIEW_REQUEST' ||
        action.type === 'APMS_OVERVIEW_REQUEST'
    ) {
        return initialState;
    }

    if (action.type === 'ORDERS_OVERVIEW_SUCCESS') {
        return action.payload;
    }

    if (action.type === 'APMS_OVERVIEW_SUCCESS') {
        return action.payload;
    }

    return state;
}

export default analyticsOverviewReducer;
